import { types } from 'mobx-state-tree';

import { FireHydrantValues, FirehallValues, HeatingValues } from '../definitions/InsCommon';


export default types
    .model('ConstructionModel', {
        yearBuilt: types.maybeNull(types.string),

        hasConciergeOrSecurity: types.maybeNull(types.boolean),
        hasMonitoredFireAlarm: types.maybeNull(types.boolean),
        hasMonitoredBurglarAlarm: types.maybeNull(types.boolean),

        fireHydrant: types.optional(
            types.enumeration(Object.values(FireHydrantValues)),
            FireHydrantValues.THREE_HUNDRED,
        ),
        firehall: types.optional(types.enumeration(Object.values(FirehallValues)), FirehallValues.WITHIN_FIVE),
        heating: types.optional(types.enumeration(Object.values(HeatingValues)), HeatingValues.CENTRAL),
    })
    .views(self => ({
        get isComplete() {
            return (
                self.yearBuilt !== null
                && self.hasConciergeOrSecurity !== null
                && self.hasMonitoredFireAlarm !== null
                && self.hasMonitoredBurglarAlarm !== null
                && self.fireHydrant !== null
                && self.firehall !== null
                && self.heating !== null
            );
        },
    }));
